import { Union, Record } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { notificationBox, DashboardProps_$reflection } from "./Shared.fs.js";
import { union_type, class_type, record_type, lambda_type, unit_type, bool_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { GlobalMessageBox_InfoWithTitle, GlobalMsg, GlobalMessageBox_Error_Z721C83C5, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { Dashboard_DigitaleKundenrechnung, Dashboard_ToggleNotificationRequest_$reflection, Dashboard_ToggleNotificationRequest, Dashboard_DigitaleKundenrechnung_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { sendJson, errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { int32ToString, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { request } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { value as value_2 } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/./Fable.React.UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/../Fable.Elmish.4.2.0/program.fs.js";
import { reactApi } from "../../../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { nothing } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { bfsTile } from "../Shared/Tile.fs.js";
import * as react from "react";

export class Props extends Record {
    constructor(Dashboard, OnVisibilityChanged) {
        super();
        this.Dashboard = Dashboard;
        this.OnVisibilityChanged = OnVisibilityChanged;
    }
}

export function Props_$reflection() {
    return record_type("Dashboard.DigitaleKundenrechnung.Props", [], Props, () => [["Dashboard", DashboardProps_$reflection()], ["OnVisibilityChanged", lambda_type(bool_type, unit_type)]]);
}

export class Model extends Record {
    constructor(GlobalDispatch, Loading, Data, SavingToggle) {
        super();
        this.GlobalDispatch = GlobalDispatch;
        this.Loading = Loading;
        this.Data = Data;
        this.SavingToggle = SavingToggle;
    }
}

export function Model_$reflection() {
    return record_type("Dashboard.DigitaleKundenrechnung.Model", [], Model, () => [["GlobalDispatch", lambda_type(GlobalMsg_$reflection(), unit_type)], ["Loading", bool_type], ["Data", Dashboard_DigitaleKundenrechnung_$reflection()], ["SavingToggle", bool_type]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadData", "LoadDataCompleted", "ToggleBenachrichtigung", "NotificationToggled"];
    }
}

export function Msg_$reflection() {
    return union_type("Dashboard.DigitaleKundenrechnung.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Dashboard_DigitaleKundenrechnung_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Dashboard_DigitaleKundenrechnung_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]]]);
}

export function Http_loadAnstehendeZahlungen() {
    const response = fetch("/api/dashboard/digitale-kundenrechnung", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Dashboard_DigitaleKundenrechnung_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_setNotificationForBelegpruefungAbgeschlossen(enabled) {
    const payload = new Dashboard_ToggleNotificationRequest(enabled);
    return sendJson("/api/dashboard/set-notification-for-digitale-kundenrechnung", toString(0, Auto_generateBoxedEncoder_437914C6(Dashboard_ToggleNotificationRequest_$reflection(), undefined, undefined, undefined)(payload)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function State_init(props) {
    return [new Model(props.GlobalDispatch, true, new Dashboard_DigitaleKundenrechnung(false), true), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    switch (msg.tag) {
        case 1:
            if (msg.fields[0].tag === 1) {
                model.GlobalDispatch(new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Ihre Daten zur digitalen Kundenrechnung können zur Zeit leider nicht geladen werden.")]));
                return [new Model(model.GlobalDispatch, false, model.Data, model.SavingToggle), Cmd_none()];
            }
            else {
                return [new Model(model.GlobalDispatch, false, msg.fields[0].fields[0], false), Cmd_none()];
            }
        case 2: {
            const newValue = !model.Data.DigitaleKundenrechnungAktiviert;
            return [new Model(model.GlobalDispatch, model.Loading, new Dashboard_DigitaleKundenrechnung(newValue), false), request(Http_setNotificationForBelegpruefungAbgeschlossen, newValue, (Item_2) => (new Msg(3, [Item_2])))];
        }
        case 3:
            if (msg.fields[0].tag === 1) {
                model.GlobalDispatch(new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Ihre neuen Benachrichtigungseinstellungen können zur Zeit leider nicht gespeichert werden.")]));
                return [new Model(model.GlobalDispatch, model.Loading, new Dashboard_DigitaleKundenrechnung(!model.Data.DigitaleKundenrechnungAktiviert), false), Cmd_none()];
            }
            else {
                model.GlobalDispatch(new GlobalMsg(3, [GlobalMessageBox_InfoWithTitle("Postzustellung im Kundenportal eingeschaltet", "Zukünftig werden alle Briefe an Sie hier ins Kundenportal zugestellt.")]));
                return [new Model(model.GlobalDispatch, model.Loading, model.Data, false), Cmd_none()];
            }
        default:
            return [new Model(model.GlobalDispatch, true, model.Data, true), request(Http_loadAnstehendeZahlungen, undefined, (Item) => (new Msg(1, [Item])))];
    }
}

export const View = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_2("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Dashboard\\DigitaleKundenrechnung.fs") + "#L") + int32ToString(value_2(120))) + ";") + "Dashboard.DigitaleKundenrechnung.Props", value_2("View"), (props) => {
    let children_12, children, children_10, children_4;
    let patternInput;
    const init = State_init(props.Dashboard);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, State_update, (_arg, _arg_1) => {
    }), undefined, undefined);
    const model_1 = patternInput[0];
    const isVisible = !model_1.Loading && !model_1.Data.DigitaleKundenrechnungAktiviert;
    const dependencies_2 = [isVisible];
    reactApi.useEffect(() => {
        props.OnVisibilityChanged(isVisible);
    }, dependencies_2);
    if (!isVisible) {
        return nothing;
    }
    else {
        const footer = notificationBox("Digitale Kundenrechnung", false, false, (_arg_2) => {
            patternInput[1](new Msg(2, []));
        }, "Digitale-Kundenrechnung-Toggle");
        return bfsTile("Digitale Kundenrechnung", undefined, undefined, (children_12 = [(children = [react.createElement("img", {
            className: "dashboard-icon",
            src: "dashboard/kundenrechnung.svg",
        })], react.createElement("div", {
            className: "is-hidden-mobile is-hidden-tablet-only is-hidden-desktop-only dashboard-hero",
        }, ...children)), (children_10 = [(children_4 = [react.createElement("b", {}, "Umweltfreundlich & schnell")], react.createElement("div", {}, ...children_4)), react.createElement("div", {
            className: "is-size-7",
        }, "Erhalten Sie Ihre Kundenrechnung und Benachrichtigungen via E-Mail."), react.createElement("a", {
            className: "is-size-7",
            href: "/#settings",
        }, "Mehr erfahren!")], react.createElement("div", {
            className: "",
        }, ...children_10))], react.createElement("div", {
            className: "digitale-kundenrechnung",
        }, ...children_12)), footer);
    }
}, undefined, undefined, "Of");

//# sourceMappingURL=DigitaleKundenrechnung.fs.js.map
